export default "__VITE_ASSET__CogX8NgU__"